module.exports = __webpack_public_path__ + "img/list_default4.da38fd31.png";